module.exports = __webpack_public_path__ + "img/confirmation.c36e41b9.jpg";